//
// Module for the Plan Transfer wizard's Settings step
//
rs.module("participant/member/plantransfer/wizard/settingsstep",

    [ "common/select-helper" ],

    function (selectHelper) {

        // Initialize the module
        function initialize(jsSelectors, backendUrls) {

            var settingsDiv = $.js(jsSelectors.settingsDiv);
            var fromPlanSelect = settingsDiv.js(jsSelectors.fromPlanSelect);
            var fromEmployerSelect = settingsDiv.js(jsSelectors.fromEmployerSelect);
            var toPlanSelect = settingsDiv.js(jsSelectors.toPlanSelect);
            var loadingSpinner = settingsDiv.js(jsSelectors.loadingSpinner);

            // Get Select Helper for toPlanSelect since we're updating its options and properties
            var toPlanSelectHelper = selectHelper.getHelper(toPlanSelect);

            fromPlanSelect.change(repopulateTransferToPlans);
            fromEmployerSelect.change(repopulateTransferToPlans);

            // From Employer selection changed
            function repopulateTransferToPlans() {
                loadingSpinner.show();

                // get selected from plan/employer
                var selectedFromPlanKey = fromPlanSelect.val();
                var selectedFromEmployerKey = fromEmployerSelect.val();

                toPlanSelectHelper.loadOptionsFrom(
                    backendUrls.getTransferToPlanOptions,
                    {
                        transferFromPlanKey: selectedFromPlanKey,
                        transferFromEmployerKey: selectedFromEmployerKey
                    },
                    null,
                    function () { loadingSpinner.hide(); });    
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);